import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function BlogCard({ post, index = 0 }) {
  const readTime = post.readTime > 0 ? post.readTime : Math.max(2, Math.ceil((post.content || '').length / 800));
  const firstTag = (post.tags || [])[0] || '';

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.06, ease: [0.4, 0, 0.2, 1] }}
    >
      <Link to={`/post/${post.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
        <div className="card-hover" style={{
          background: 'var(--bg-card)',
          borderRadius: 'var(--radius-lg)',
          overflow: 'hidden',
          cursor: 'pointer',
        }}>
          {/* Image */}
          {post.image && (
            <div className="img-zoom" style={{
              borderRadius: 'var(--radius-md)',
              margin: '0.6rem 0.6rem 0',
              overflow: 'hidden',
            }}>
              <img
                src={post.image}
                alt={post.title}
                style={{
                  width: '100%',
                  aspectRatio: '1 / 1',
                  objectFit: 'cover',
                  display: 'block',
                  borderRadius: 'var(--radius-md)',
                }}
              />
            </div>
          )}

          {/* Text content */}
          <div style={{ padding: '0.85rem 1rem 1rem' }}>
            <div style={{
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'space-between',
              gap: '0.5rem',
            }}>
              <h3 style={{
                fontFamily: 'var(--font-sans)',
                fontSize: '0.95rem',
                lineHeight: 1.35,
                fontWeight: 500,
                flex: 1,
              }}>
                {post.title}
              </h3>
              <span style={{
                fontSize: '0.75rem',
                color: 'var(--text-tertiary)',
                flexShrink: 0,
                marginTop: '0.1rem',
                width: '22px',
                height: '22px',
                borderRadius: '6px',
                background: 'var(--bg-body)',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="7" y1="17" x2="17" y2="7" /><polyline points="7 7 17 7 17 17" />
                </svg>
              </span>
            </div>
            <div style={{
              fontSize: '0.78rem',
              color: 'var(--text-tertiary)',
              marginTop: '0.35rem',
            }}>
              {firstTag}{firstTag && ' - '}{readTime} min
            </div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
